import type { ILandingPageTestimonialItem } from '@share/common-types';

/**
 * Pre-written testimonial set shown when `showFakeTestimonials` is enabled (marketing / preview only).
 */
export const FAKE_LANDING_TESTIMONIALS: ReadonlyArray<ILandingPageTestimonialItem> = [
  {
    name: 'Sarah & Michael',
    location: 'Denver, CO',
    quote:
      'This was the vacation of a lifetime! The cruise was incredible and the resort stay was pure luxury. We saved so much compared to booking separately.',
    avatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80',
    rating: 5,
  },
  {
    name: 'The Johnson Family',
    location: 'Austin, TX',
    quote:
      'Perfect for our family of four. The kids loved the cruise activities and we appreciated the flexibility to choose our destinations.',
    avatarUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80',
    rating: 5,
  },
  {
    name: 'Linda Martinez',
    location: 'Miami, FL',
    quote:
      'Best cruise deal ever! This certificate gave me the best value. The concierge service made booking a breeze.',
    avatarUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80',
    rating: 5,
  },
];
